import React, { Component } from 'react'
import {
  map
} from 'lodash'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

import DropdownOption from './dropdownOption'

import Button from '../button'
import Icon from '../icon'
import Text from '../text'
import Wrapper from '../wrapper'

class Dropdown extends Component {
  constructor () {
    super()

    this.state = {
      visible: false
    }
  }

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClick)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClick)
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node
  }

  handleClick = (event) => {
    if (this.state.visible && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ visible: false })
    }
  }

  open = () => {
    this.setState({ visible: true })
  }

  ALLOWED_MODIFIERS = []

  componentClassNames = () => {
    return bemClasses('dropdown', this.ALLOWED_MODIFIERS, this.props)
  }

  renderOption = (optionProps) => {
    if (optionProps.visibilityFunc && !optionProps.visibilityFunc(this.props.object)) { return }

    return (
      <DropdownOption
        key={Math.random()}
        object={this.props.object}
        {...optionProps}
      />
    )
  }

  dropdownOptionsClass = () => {
    if (this.state.visible) {
      return 'dropdown__options dropdown__options--visible'
    }

    return 'dropdown__options'
  }

  renderDesktopClickable = () => {
    return (
      <Wrapper
        middle
        hidden={{ xs: true, sm: true, md: true }}
        onClick={this.open}>
        <Text
          inline
          spacing={{ right: true }}>
          Options
        </Text>
        <Icon
          icon={this.props.icon || 'down-arrow'}
          type='svg'
          medium={this.props.iconOnly}
          small={!this.props.iconOnly}
        />
      </Wrapper>
    )
  }

  renderMobileClickable = () => {
    return (
      <Button
        downArrowIcon={!this.state.visible}
        upArrowIcon={this.state.visible}
        onClick={this.open}
        green
        visible={{ xs: true, sm: true, md: true }}
      />
    )
  }

  renderDropdown = () => {
    return (
      <div className={this.dropdownOptionsClass()}>
        { map(this.props.options, this.renderOption)}
      </div>
    )
  }

  render = () => {
    return (
      <span
        ref={this.setWrapperRef}
        className={this.componentClassNames()}
        onClick={this.open}>
        <div className='dropdown__wrapper'>
          <div className='dropdown__link'>
            { this.renderDesktopClickable() }
            { this.renderMobileClickable() }
            { this.renderDropdown() }
          </div>
        </div>
      </span>
    )
  }
}

export default Dropdown
